<template>
  <div>
    <!-- <img src="@/assets/img/lcg-logo.png" class="fm-logo" /> -->
    <div class='slider' :class='{swipe: swipe}'></div>
  </div>
</template>

<script>
import { db, auth } from "@/config/firebaseInit";
var moment = require("moment");
var tz = require("moment-timezone");

export default {
  name: "heading",
  components: {},
  data() {
    return {
      swipe: false,
    };
  },
  mounted() {},
  created() {

  },
  firestore() {
    return {};
  },
  methods: {
    getIds() {
      let vm = this;
      db.collection("kiosks")
        .where("slug", "==", vm.$route.params.kiosk_id)
        .get()
        .then(snashot => {
          vm.kiosk_id = snashot.docs[0].id;
          localStorage.setItem("id", vm.kiosk_id);
          vm.kiosk = snashot.docs[0].data();
          vm.saveLastSignal();
        });
    }
  },
  watch: {
    $route(to, from) {
    }
  }
};
</script>

<style lang='scss'>
.slider {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  height: 100%;
  background: white;
  width: 0;
  transition: width .5s;

  &.swipe {
    width: 100%;
  }
}

.fm-logo {
  padding: 20px;
  right: 0;
  position: absolute;
  top: 0;
  z-index: 2;
  max-width: 450px;
  filter: brightness(0.972);
  @media screen and (max-width: 700px){
    width: 90%;
    padding: 0;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
